export const colors = ['#FF6492', '#141446', '#7A77FF'];

export const monthsInYearFormatter = (value: number | string | Date) => {
  const date = new Date(value);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  return `${month}/${date.getFullYear()}`;
};
